import React from 'react'

import ButtonBackToPartner from 'components/Buttons/ButtonBackToPartner/ButtonBackToPartner'
import CancelApplicationPageHeadingIcon from 'assets/icons/cancel-application-page-heading-icon.svg'
import useTextContents from 'common/hooks/useTextContents'
import { BACK_TO_PARTNER_LINK_TYPES } from 'components/Buttons/ButtonBackToPartner/BackToPartnerButtonProps'

import './CancelApplicationPageStyles.scss'

/**
 * Komponent obsługujący stronę "Anulowanie wniosku" 
*/
const CancelApplicationPage = (): JSX.Element => {

   const cancelPageTextContents = useTextContents()

   return (
      <div className='cancel-application-page-outer-wrapper'>
         <img className='cancel-application-page-heading-icon' src={CancelApplicationPageHeadingIcon} alt='odmowa'/>
         <h1 className='cancel-application-page-heading-text'>{cancelPageTextContents('cancelApplicationPage.header')}</h1>
         <div className='cancel-application-page-description-text-wrapper'>
            <p>{cancelPageTextContents('cancelApplicationPage.mainContent.part1')}</p>
            <p>{cancelPageTextContents('cancelApplicationPage.mainContent.part2')}</p>
         </div>
         <ButtonBackToPartner linkType={BACK_TO_PARTNER_LINK_TYPES.FAILURE} />
      </div>
   )
}

export default CancelApplicationPage